import React, { useState, useContext, useEffect, use } from 'react';
import { AuthContext, AuthProvider } from '../context/AuthContext';
import { getUser, getPaystore, getCompanies, updateSelectedCompany } from '../../api/api';
import HeaderBar from './HeaderBar';

const applyTheme = (theme) => {
  document.getElementById("theme-css").href = theme === "light" ? "css/theme-light.css?v=15" : "css/theme-dark.css?v=30";
  localStorage.setItem("theme", theme);
};

const Header = (props) => {
  const { user } = useContext(AuthContext);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [myCompany, setMyCompany] = useState(null);
  const [role, setRole] = useState(null);
  const [userID, setUserID] = useState(null);

  const [theme, setTheme] = useState(localStorage.getItem("theme") === "light" ? "light" : "dark");

  const toggleTheme = () => {
    const next = theme === "light" ? "dark" : "light";
    applyTheme(next);
    setTheme(next);
  };

  const loadUserDetails = async (user) => {
    const response = await getUser(user);
    props.setUserDetails(response.data.data.getUserListing.edges[0].node);
    setRole(response.data.data.getUserListing.edges[0].node.role);
    setUserID(response.data.data.getUserListing.edges[0].node.id);
    setMyCompany(response.data.data.getUserListing.edges[0].node.Company[0].dataID);
  };

  const loadCompanies = async () => {
    const response = await getCompanies();
    setCompanies(response.data.data.getCompanyListing.edges.map(edge => edge.node));
  };

  useEffect(() => {
    loadUserDetails(user);
    loadCompanies();
  }, []);

  useEffect(() => {
    if (selectedCompany) {
      updateSelectedCompany(userID, selectedCompany).then(() => {
        window.location.reload();
      });
    }
  }, [selectedCompany]);

  return (
    <header className="header-top pb-0 mb-3" header-theme="light">
      <div className="container-fluid">
        <div className="d-flex justify-content-between">
          <div className="top-menu d-flex align-items-center">
            <a className="header-brand" href="/">
              <div className="logo-img">
                <img src="images/rebootLogo.png" height={50} className="header-brand-img" alt="Reboot" />
              </div>
            </a>
          </div>
          <div className="top-menu d-flex align-items-center">
            <button type="button" className="nav-link ml-10" id="apps_modal_btn" onClick={toggleTheme}
              title={theme === "light" ? "Passa al tema scuro" : "Passa al tema chiaro"}>
              <span className="material-symbols-outlined">{theme === "light" ? "dark_mode" : "light_mode"}</span>
            </button>
            {/* <button type="button" className="nav-link ml-10" id="apps_modal_btn" onClick={() => window.location.reload()}>
              <span className="material-symbols-outlined" style={{ fontSize: "24px" }}>
                refresh
              </span>
            </button> */}
            <button type="button" className="nav-link ml-10" id="apps_modal_btn" data-toggle="modal" data-target="#appsModal">
              <span className="material-symbols-outlined" style={{ fontSize: "24px" }}>
                apps
              </span>
            </button>
            <div className="dropdown">
              <a className="dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <img className="avatar" src={props.userDetails && props.userDetails.avatar ? "https://x1.dixxip.com/dixcore/public/var/assets" + props.userDetails.avatar.fullpath : null} alt="" /></a>
              <div className="dropdown-menu dropdown-menu-right user-dropdown" aria-labelledby="userDropdown">
                {role < 1 && companies.length > 0 && (
                  companies.map(company => (
                    <a key={company.id} className="dropdown-item d-flex align-items-center justify-content-between" onClick={() => setSelectedCompany(company.id)} href="#">
                      <span className="d-flex align-items-center"><img src={company.logo ? "https://x1.dixxip.com/dixcore/public/var/assets" + company.logo.fullpath : null} alt="" height={16} /> <span className="ml-2">{company.name}</span></span>
                      {myCompany === company.dataID && (
                        <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>
                          check
                        </span>
                      )}
                    </a>
                  ))
                )}
                <a className="dropdown-item d-flex align-items-center" href="/logout">
                  <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>
                    power_settings_new
                  </span> <span className="ml-2">Logout</span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <HeaderBar userDetails={props.userDetails} />
    </header>
  )
}
export default Header;